import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { CloudProductVisibilityType } from "@omni/types/api/product/cloud/shared/enums/productVisibilityType.enum";
import { AlgoliaSearchProductVisibilityType } from "@omni/types/api/search/algolia/product/shared/enums/productVisibilityType.enum";
import { BffSearchProductVisibilityType } from "@omni/types/api/search/bff/product/shared/enums/productVisibilityType.enum";

const fromCloudToBffMap: Record<
    CloudProductVisibilityType,
    ProductVisibilityType
> = {
    [CloudProductVisibilityType.Default]: ProductVisibilityType.Default,
    [CloudProductVisibilityType.Delivery]: ProductVisibilityType.Delivery,
    [CloudProductVisibilityType.Collect]: ProductVisibilityType.Collect,
    [CloudProductVisibilityType.DeliveryAndCollect]:
        ProductVisibilityType.DeliveryAndCollect,
    [CloudProductVisibilityType.CollectAndExpressDelivery]:
        ProductVisibilityType.CollectAndExpressDelivery,
    [CloudProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [CloudProductVisibilityType.Free]: ProductVisibilityType.Free,
    [CloudProductVisibilityType.Offline]: ProductVisibilityType.Offline,
    [CloudProductVisibilityType.NotAvailable]:
        ProductVisibilityType.NotAvailable,
    [CloudProductVisibilityType.TemporaryNotAvailable]:
        ProductVisibilityType.TemporaryNotAvailable,
    [CloudProductVisibilityType.OnlyAvailableInStore]:
        ProductVisibilityType.OnlyAvailableInStore
};

const fromBffToCloudMap: Record<
    ProductVisibilityType,
    CloudProductVisibilityType
> = {
    [ProductVisibilityType.Default]: CloudProductVisibilityType.Default,
    [ProductVisibilityType.Delivery]: CloudProductVisibilityType.Delivery,
    [ProductVisibilityType.Collect]: CloudProductVisibilityType.Collect,
    [ProductVisibilityType.DeliveryAndCollect]:
        CloudProductVisibilityType.DeliveryAndCollect,
    [ProductVisibilityType.CollectAndExpressDelivery]:
        CloudProductVisibilityType.CollectAndExpressDelivery,
    [ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        CloudProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [ProductVisibilityType.Free]: CloudProductVisibilityType.Free,
    [ProductVisibilityType.Offline]: CloudProductVisibilityType.Offline,
    [ProductVisibilityType.NotAvailable]:
        CloudProductVisibilityType.NotAvailable,
    [ProductVisibilityType.TemporaryNotAvailable]:
        CloudProductVisibilityType.TemporaryNotAvailable,
    [ProductVisibilityType.OnlyAvailableInStore]:
        CloudProductVisibilityType.OnlyAvailableInStore
};

const fromAlgoliaSearchToBffMap: Record<
    AlgoliaSearchProductVisibilityType,
    ProductVisibilityType
> = {
    [AlgoliaSearchProductVisibilityType.Default]: ProductVisibilityType.Default,
    [AlgoliaSearchProductVisibilityType.Delivery]:
        ProductVisibilityType.Delivery,
    [AlgoliaSearchProductVisibilityType.Collect]: ProductVisibilityType.Collect,
    [AlgoliaSearchProductVisibilityType.DeliveryAndCollect]:
        ProductVisibilityType.DeliveryAndCollect,
    [AlgoliaSearchProductVisibilityType.CollectAndExpressDelivery]:
        ProductVisibilityType.CollectAndExpressDelivery,
    [AlgoliaSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [AlgoliaSearchProductVisibilityType.Free]: ProductVisibilityType.Free,
    [AlgoliaSearchProductVisibilityType.Offline]: ProductVisibilityType.Offline,
    [AlgoliaSearchProductVisibilityType.NotAvailable]:
        ProductVisibilityType.NotAvailable,
    [AlgoliaSearchProductVisibilityType.TemporaryNotAvailable]:
        ProductVisibilityType.TemporaryNotAvailable,
    [AlgoliaSearchProductVisibilityType.OnlyAvailableInStore]:
        ProductVisibilityType.OnlyAvailableInStore
};

const fromAlgoliaSearchToBffSearchMap: Record<
    AlgoliaSearchProductVisibilityType,
    BffSearchProductVisibilityType
> = {
    [AlgoliaSearchProductVisibilityType.Default]:
        BffSearchProductVisibilityType.Default,
    [AlgoliaSearchProductVisibilityType.Delivery]:
        BffSearchProductVisibilityType.Delivery,
    [AlgoliaSearchProductVisibilityType.Collect]:
        BffSearchProductVisibilityType.Collect,
    [AlgoliaSearchProductVisibilityType.DeliveryAndCollect]:
        BffSearchProductVisibilityType.DeliveryAndCollect,
    [AlgoliaSearchProductVisibilityType.CollectAndExpressDelivery]:
        BffSearchProductVisibilityType.CollectAndExpressDelivery,
    [AlgoliaSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        BffSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [AlgoliaSearchProductVisibilityType.Free]:
        BffSearchProductVisibilityType.Free,
    [AlgoliaSearchProductVisibilityType.Offline]:
        BffSearchProductVisibilityType.Offline,
    [AlgoliaSearchProductVisibilityType.NotAvailable]:
        BffSearchProductVisibilityType.NotAvailable,
    [AlgoliaSearchProductVisibilityType.TemporaryNotAvailable]:
        BffSearchProductVisibilityType.TemporaryNotAvailable,
    [AlgoliaSearchProductVisibilityType.OnlyAvailableInStore]:
        BffSearchProductVisibilityType.OnlyAvailableInStore
};

const fromBffToAlgoliaSearchMap: Record<
    ProductVisibilityType,
    AlgoliaSearchProductVisibilityType
> = {
    [ProductVisibilityType.Default]: AlgoliaSearchProductVisibilityType.Default,
    [ProductVisibilityType.Delivery]:
        AlgoliaSearchProductVisibilityType.Delivery,
    [ProductVisibilityType.Collect]: AlgoliaSearchProductVisibilityType.Collect,
    [ProductVisibilityType.DeliveryAndCollect]:
        AlgoliaSearchProductVisibilityType.DeliveryAndCollect,
    [ProductVisibilityType.CollectAndExpressDelivery]:
        AlgoliaSearchProductVisibilityType.CollectAndExpressDelivery,
    [ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        AlgoliaSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [ProductVisibilityType.Free]: AlgoliaSearchProductVisibilityType.Free,
    [ProductVisibilityType.Offline]: AlgoliaSearchProductVisibilityType.Offline,
    [ProductVisibilityType.NotAvailable]:
        AlgoliaSearchProductVisibilityType.NotAvailable,
    [ProductVisibilityType.TemporaryNotAvailable]:
        AlgoliaSearchProductVisibilityType.TemporaryNotAvailable,
    [ProductVisibilityType.OnlyAvailableInStore]:
        AlgoliaSearchProductVisibilityType.OnlyAvailableInStore
};

const fromCloudToAlgoliaSearchMap: Record<
    CloudProductVisibilityType,
    AlgoliaSearchProductVisibilityType
> = {
    [CloudProductVisibilityType.Default]:
        AlgoliaSearchProductVisibilityType.Default,
    [CloudProductVisibilityType.Delivery]:
        AlgoliaSearchProductVisibilityType.Delivery,
    [CloudProductVisibilityType.Collect]:
        AlgoliaSearchProductVisibilityType.Collect,
    [CloudProductVisibilityType.DeliveryAndCollect]:
        AlgoliaSearchProductVisibilityType.DeliveryAndCollect,
    [CloudProductVisibilityType.CollectAndExpressDelivery]:
        AlgoliaSearchProductVisibilityType.CollectAndExpressDelivery,
    [CloudProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        AlgoliaSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [CloudProductVisibilityType.Free]: AlgoliaSearchProductVisibilityType.Free,
    [CloudProductVisibilityType.Offline]:
        AlgoliaSearchProductVisibilityType.Offline,
    [CloudProductVisibilityType.NotAvailable]:
        AlgoliaSearchProductVisibilityType.NotAvailable,
    [CloudProductVisibilityType.TemporaryNotAvailable]:
        AlgoliaSearchProductVisibilityType.TemporaryNotAvailable,
    [CloudProductVisibilityType.OnlyAvailableInStore]:
        AlgoliaSearchProductVisibilityType.OnlyAvailableInStore
};

const fromBffSearchToBffMap: Record<
    BffSearchProductVisibilityType,
    ProductVisibilityType
> = {
    [BffSearchProductVisibilityType.Default]: ProductVisibilityType.Default,
    [BffSearchProductVisibilityType.Delivery]: ProductVisibilityType.Delivery,
    [BffSearchProductVisibilityType.Collect]: ProductVisibilityType.Collect,
    [BffSearchProductVisibilityType.DeliveryAndCollect]:
        ProductVisibilityType.DeliveryAndCollect,
    [BffSearchProductVisibilityType.CollectAndExpressDelivery]:
        ProductVisibilityType.CollectAndExpressDelivery,
    [BffSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [BffSearchProductVisibilityType.Free]: ProductVisibilityType.Free,
    [BffSearchProductVisibilityType.Offline]: ProductVisibilityType.Offline,
    [BffSearchProductVisibilityType.NotAvailable]:
        ProductVisibilityType.NotAvailable,
    [BffSearchProductVisibilityType.TemporaryNotAvailable]:
        ProductVisibilityType.TemporaryNotAvailable,
    [BffSearchProductVisibilityType.OnlyAvailableInStore]:
        ProductVisibilityType.OnlyAvailableInStore
};

const fromBffSearchToAlgoliaSearchMap: Record<
    BffSearchProductVisibilityType,
    AlgoliaSearchProductVisibilityType
> = {
    [BffSearchProductVisibilityType.Default]:
        AlgoliaSearchProductVisibilityType.Default,
    [BffSearchProductVisibilityType.Delivery]:
        AlgoliaSearchProductVisibilityType.Delivery,
    [BffSearchProductVisibilityType.Collect]:
        AlgoliaSearchProductVisibilityType.Collect,
    [BffSearchProductVisibilityType.DeliveryAndCollect]:
        AlgoliaSearchProductVisibilityType.DeliveryAndCollect,
    [BffSearchProductVisibilityType.CollectAndExpressDelivery]:
        AlgoliaSearchProductVisibilityType.CollectAndExpressDelivery,
    [BffSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        AlgoliaSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [BffSearchProductVisibilityType.Free]:
        AlgoliaSearchProductVisibilityType.Free,
    [BffSearchProductVisibilityType.Offline]:
        AlgoliaSearchProductVisibilityType.Offline,
    [BffSearchProductVisibilityType.NotAvailable]:
        AlgoliaSearchProductVisibilityType.NotAvailable,
    [BffSearchProductVisibilityType.TemporaryNotAvailable]:
        AlgoliaSearchProductVisibilityType.TemporaryNotAvailable,
    [BffSearchProductVisibilityType.OnlyAvailableInStore]:
        AlgoliaSearchProductVisibilityType.OnlyAvailableInStore
};

const fromBffToBffSearchMap: Record<
    ProductVisibilityType,
    BffSearchProductVisibilityType
> = {
    [ProductVisibilityType.Default]: BffSearchProductVisibilityType.Default,
    [ProductVisibilityType.Delivery]: BffSearchProductVisibilityType.Delivery,
    [ProductVisibilityType.Collect]: BffSearchProductVisibilityType.Collect,
    [ProductVisibilityType.DeliveryAndCollect]:
        BffSearchProductVisibilityType.DeliveryAndCollect,
    [ProductVisibilityType.CollectAndExpressDelivery]:
        BffSearchProductVisibilityType.CollectAndExpressDelivery,
    [ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        BffSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [ProductVisibilityType.Free]: BffSearchProductVisibilityType.Free,
    [ProductVisibilityType.Offline]: BffSearchProductVisibilityType.Offline,
    [ProductVisibilityType.NotAvailable]:
        BffSearchProductVisibilityType.NotAvailable,
    [ProductVisibilityType.TemporaryNotAvailable]:
        BffSearchProductVisibilityType.TemporaryNotAvailable,
    [ProductVisibilityType.OnlyAvailableInStore]:
        BffSearchProductVisibilityType.OnlyAvailableInStore
};

const fromCloudToBffSearchMap: Record<
    CloudProductVisibilityType,
    BffSearchProductVisibilityType
> = {
    [CloudProductVisibilityType.Default]:
        BffSearchProductVisibilityType.Default,
    [CloudProductVisibilityType.Delivery]:
        BffSearchProductVisibilityType.Delivery,
    [CloudProductVisibilityType.Collect]:
        BffSearchProductVisibilityType.Collect,
    [CloudProductVisibilityType.DeliveryAndCollect]:
        BffSearchProductVisibilityType.DeliveryAndCollect,
    [CloudProductVisibilityType.CollectAndExpressDelivery]:
        BffSearchProductVisibilityType.CollectAndExpressDelivery,
    [CloudProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]:
        BffSearchProductVisibilityType.DeliveryAndExpressDeliveryAndCollect,
    [CloudProductVisibilityType.Free]: BffSearchProductVisibilityType.Free,
    [CloudProductVisibilityType.Offline]:
        BffSearchProductVisibilityType.Offline,
    [CloudProductVisibilityType.NotAvailable]:
        BffSearchProductVisibilityType.NotAvailable,
    [CloudProductVisibilityType.TemporaryNotAvailable]:
        BffSearchProductVisibilityType.TemporaryNotAvailable,
    [CloudProductVisibilityType.OnlyAvailableInStore]:
        BffSearchProductVisibilityType.OnlyAvailableInStore
};

export const ProductVisibilityTypeMapper = {
    fromCloudToBff: (visibilityType: CloudProductVisibilityType) =>
        fromCloudToBffMap[visibilityType],
    fromCloudToAlgoliaSearch: (visibilityType: CloudProductVisibilityType) =>
        fromCloudToAlgoliaSearchMap[visibilityType],
    fromCloudToBffSearch: (visibilityType: CloudProductVisibilityType) =>
        fromCloudToBffSearchMap[visibilityType],
    fromBffToCloud: (visibilityType: ProductVisibilityType) =>
        fromBffToCloudMap[visibilityType],
    fromBffToAlgoliaSearch: (visibilityType: ProductVisibilityType) =>
        fromBffToAlgoliaSearchMap[visibilityType],
    fromBffToBffSearch: (visibilityType: ProductVisibilityType) =>
        fromBffToBffSearchMap[visibilityType],
    fromAlgoliaSearchToBff: (
        visibilityType: AlgoliaSearchProductVisibilityType
    ) => fromAlgoliaSearchToBffMap[visibilityType],
    fromAlgoliaSearchToBffSearch: (
        visibilityType: AlgoliaSearchProductVisibilityType
    ) => fromAlgoliaSearchToBffSearchMap[visibilityType],
    fromBffSearchToBff: (visibilityType: BffSearchProductVisibilityType) =>
        fromBffSearchToBffMap[visibilityType],
    fromBffSearchToAlgoliaSearch: (
        visibilityType: BffSearchProductVisibilityType
    ) => fromBffSearchToAlgoliaSearchMap[visibilityType]
};
